import { blueprints } from '../blueprints/blueprints-sidecar'
import { IBlueprintSaved } from '../blueprints/blueprintsSaver'
import { blueprintsSaver } from '../blueprints/blueprintsSaver-sidecar'
import { asteroids } from '../entities/asteroids-sidecar'
import { IAsteroidSaved } from '../entities/asteroidsSaver'
import { asteroidsSaver } from '../entities/asteroidsSaver-sidecar'
import { cargoes } from '../entities/cargoes-sidecar'
import { ICargoSaved } from '../entities/cargoesSaver'
import { cargoesSaver } from '../entities/cargoesSaver-sidecar'
import { machines } from '../machines/machines-sidecar'
import { IMachineSaved } from '../machines/machinesSaver'
import { machinesSaver } from '../machines/machinesSaver-sidecar'
import { monsters } from '../monsters/monsters-sidecar'
import { IMonsterSaved } from '../monsters/monstersSaver'
import { monstersSaver } from '../monsters/monstersSaver-sidecar'
import { ISavedTile } from './tilesSaver'
import { tilesSaver } from './tilesSaver-sidecar'

export interface ISavedData {
  tiles: ISavedTile[]
  asteroids: IAsteroidSaved[]
  blueprints: IBlueprintSaved[]
  machines: IMachineSaved[]
  // stacks: IStackSaved[]
  cargoes: ICargoSaved[]
  monsters: IMonsterSaved[]
  // TODO:
}

export const save = (): ISavedData => {
  let data: ISavedData = {
    tiles: tilesSaver.save(),
    asteroids: asteroidsSaver.save(),
    blueprints: blueprintsSaver.save(),
    machines: machinesSaver.save(),
    // stacks: stacksSaver.save(),
    cargoes: cargoesSaver.save(),
    monsters: monstersSaver.save(),
  }

  return data
}

export function load(dt: ISavedData) {
  tilesSaver.load(dt.tiles)

  asteroids.killAll()
  asteroidsSaver.load(dt.asteroids)

  blueprints.killAll()
  blueprintsSaver.load(dt.blueprints)

  machines.killAll()
  machinesSaver.load(dt.machines)

  // stacks.killAll()
  // stacksSaver.load(dt.stacks)

  cargoes.killAll()
  cargoesSaver.load(dt.cargoes)

  monsters.killAll()
  monstersSaver.load(dt.monsters)
}
